// Module
var code = "<md-card-content ng-bind-html=\"vm.item.trustedContent\" class=\"text-prescription\"></md-card-content>\r\n";
// Exports
module.exports = code;